import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Text } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const UploadPopup = ({ onClose }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch("/api/upload_jd", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "File upload failed.");
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        onClose();
        navigate('/afterjd', { state: { jdData: data.job_details } });
      }, 2000);

    } catch (error) {
      alert(`Upload failed: ${error.message}`);
      console.error("Error uploading file:", error);
    }
  };

  return (
    <>
      {!showSuccess && (
        <Dialog open={true} onOpenChange={onClose}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Upload Job Description</DialogTitle>
              <DialogDescription>
                <Text>Please select a file to upload.</Text>
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <Label htmlFor="file-input">Select File</Label>
                <Input
                  type="file"
                  id="file-input"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.txt"
                  className="mt-1"
                />
              </div>
              {selectedFile && <Text className="text-sm text-muted-foreground">Selected File: {selectedFile.name}</Text>}
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={onClose}>Cancel</Button>
              <Button onClick={handleUpload}>Upload JD</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {showSuccess && (
        <Dialog open={true} onOpenChange={onClose}>
          <DialogContent>
            <DialogHeader>
              <div className="flex flex-col items-center text-center space-y-4">
                <CheckCircle2 className="w-16 h-16 text-green-600" />
                <DialogTitle>Success</DialogTitle>
                <DialogDescription>
                  <Text>Job Description uploaded successfully!</Text>
                </DialogDescription>
              </div>
            </DialogHeader>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default UploadPopup;
